var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModularProgramme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5841",
    "data-name": "Group 5841",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1442",
    "data-name": "Rectangle 1442",
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5847",
    "data-name": "Group 5847",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5846",
    "data-name": "Group 5846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5845",
    "data-name": "Group 5845",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5844",
    "data-name": "Group 5844",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5843",
    "data-name": "Group 5843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5842",
    "data-name": "Group 5842",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4575",
    "data-name": "Path 4575",
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4576",
    "data-name": "Path 4576",
    d: "M112.208,81.519c.03-.01.01-.07,0-.12a2.642,2.642,0,0,0-.12-.4l-.05-.13a3.33,3.33,0,0,0-.24-.46l-.08-.1c-.09-.11-.18-.22-.28-.33l-.1-.1a3.166,3.166,0,0,0-.35-.29l-.08-.06c-.13-.08-.27-.16-.41-.23l-13.27-6.12v-4.22a11.984,11.984,0,0,0-6.02-10.32l-5.3-3.05V44.659a2.666,2.666,0,0,0-.06-.56v-.16a2.906,2.906,0,0,0-.12-.39l-.05-.13a2.94,2.94,0,0,0-.25-.46l-.07-.1a2.605,2.605,0,0,0-.27-.31l-.11-.12a2.875,2.875,0,0,0-.34-.27l-.09-.06a3.376,3.376,0,0,0-.41-.24l-14.33-6.58a3.16,3.16,0,0,0-2.59,0L53,41.849a2.462,2.462,0,0,0-.42.23l-.09.06a2.782,2.782,0,0,0-.33.27l-.12.12a2.785,2.785,0,0,0-.26.32l-.07.09a2.94,2.94,0,0,0-.25.46l-.05.14a3.563,3.563,0,0,0-.13.39v.15a3.532,3.532,0,0,0-.05.56v10.97l-5.54,3.24a11.973,11.973,0,0,0-5.92,10.32v3.34a2.859,2.859,0,0,0-.77.23L24.758,79.3c-.15.07-.28.15-.42.23l-.05.06a3.166,3.166,0,0,0-.35.29l-.1.1a3.084,3.084,0,0,0-.3.33l-.07.1a2.551,2.551,0,0,0-.25.46l-.04.13a2.671,2.671,0,0,0-.13.4v.16a2.987,2.987,0,0,0-.1.52v15.8a3.17,3.17,0,0,0,.48,1.66,3.052,3.052,0,0,0,1.29,1.15l14.22,6.55a3.107,3.107,0,0,0,2.6,0l5.68-2.65,15.43,8.84a11.979,11.979,0,0,0,11.94-.05l14.32-8.31,4.77,2.21a3.036,3.036,0,0,0,2.59,0l14.22-6.63a3.074,3.074,0,0,0,1.77-2.81V82.079a2.652,2.652,0,0,0-.05-.56m-43.7-40.01,6.83,3.15-6.83,3.14-6.83-3.15Zm11.14,7.98v8.95l-8.03,3.71V53.2Zm-22.26,0,8.03,3.71v8.94l-8.03-3.71ZM37.178,99.6l-8.03-3.7v-8.95l8.03,3.71Zm3.09-14.34-6.83-3.18,6.83-3.11,6.84,3.11ZM51.4,95.9l-8.03,3.7v-8.95l8.03-3.71Zm20.11,12.14a5.785,5.785,0,0,1-5.75,0l-11.58-6.62,1.61-.77a3.074,3.074,0,0,0,1.77-2.81V82.079a3.532,3.532,0,0,0-.05-.56v-.16a3.57,3.57,0,0,0-.12-.4l-.05-.13a2.94,2.94,0,0,0-.25-.46l-.08-.06a3.915,3.915,0,0,0-.27-.33l-.11-.1a2.366,2.366,0,0,0-.34-.29l-.08-.06a4.16,4.16,0,0,0-.42-.23l-9.84-4.53v-5.58a5.734,5.734,0,0,1,2.85-4.98l3.12-1.83a3.072,3.072,0,0,0,1.1.89l14.2,6.52a3.16,3.16,0,0,0,2.59,0l14.22-6.56a3.157,3.157,0,0,0,1.14-.88l2.94,1.68a5.761,5.761,0,0,1,2.9,4.97v4.98l-11.58,5.31a3.233,3.233,0,0,0-.41.22l-.08.07a3.066,3.066,0,0,0-.35.28l-.1.11a2.129,2.129,0,0,0-.25.34l-.07.1a2.551,2.551,0,0,0-.25.46l-.04.13c-.05.13-.09.26-.13.4v.16a3.409,3.409,0,0,0-.05.55v15.77a3.12,3.12,0,0,0,1.77,2.81l2.59,1.19Zm20.37-8.44-8.03-3.71v-8.94l8.03,3.71Zm3.09-14.32-6.82-3.2,6.82-3.15,6.84,3.15Zm11.1,10.61-8.03,3.72v-8.96l8.03-3.71Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4577",
    "data-name": "Path 4577",
    d: "M51.4,86.939V95.9l-8.03,3.7v-8.95Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4578",
    "data-name": "Path 4578",
    d: "M37.178,90.659V99.6l-8.03-3.7v-8.95Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4579",
    "data-name": "Path 4579",
    d: "M47.108,82.079l-6.84,3.18-6.83-3.18,6.83-3.11Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4580",
    "data-name": "Path 4580",
    d: "M106.068,86.939v8.95l-8.03,3.72v-8.96Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4581",
    "data-name": "Path 4581",
    d: "M91.878,90.659V99.6l-8.03-3.71v-8.94Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4582",
    "data-name": "Path 4582",
    d: "M101.808,82.079l-6.84,3.2-6.82-3.2,6.82-3.15Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4583",
    "data-name": "Path 4583",
    d: "M79.648,49.489v8.95l-8.03,3.71V53.2Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4584",
    "data-name": "Path 4584",
    d: "M75.338,44.659l-6.83,3.14-6.83-3.15,6.83-3.14Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4585",
    "data-name": "Path 4585",
    d: "M65.418,53.2v8.94l-8.03-3.71v-8.94Z",
    fill: "#02e2ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModularProgramme);
export default __webpack_public_path__ + "static/media/modular-programme.6dba533a50c033014d9f7ac0cee0fc72.svg";
export { ForwardRef as ReactComponent };